<div class="row justify-content-center align-items-center mt-3 d-flex flex-lg-row-reverse">
  <div class="col-lg-6 col-12">
    <div class="row justify-content-center mt-4">
      <div class="col-8 blue_box p-4 text-center">
        <h3 class="heading">
          <span *ngIf="isChecking">Verifying Status</span>
          <span *ngIf="isSuccess">Application Completed</span>
          <span *ngIf="isExpired">Session Expired</span>
        </h3>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-11 white_box p-4 text-center">
        <!-- Checking / Verifying State -->
        <div *ngIf="isChecking" class="py-4">
          <div class="spinner-border text-primary my-4" role="status" style="width: 3rem; height: 3rem; color: #002d3a !important;">
            <span class="visually-hidden">Loading...</span>
          </div>

          <h4 class="mt-3">Please wait...</h4>
          <p class="text-muted mt-2">{{ statusMessage }}</p>
        </div>

        <!-- Success State -->
        <div *ngIf="isSuccess" class="py-4">
          <div class="text-success my-3">
            <i class="fas fa-check-circle fa-3x" style="color: #28a745;"></i>
          </div>

          <h4 class="mt-3 text-success">Application Completed!</h4>
          <p class="text-muted mt-2">Redirecting to confirmation...</p>
        </div>

        <!-- Not Completed / Session Expired State -->
        <div *ngIf="isExpired" class="py-4">
          <img src="../../assets/images/assist-time-limit.png" class="img mt-2" style="width: 35%; max-width: 180px;" alt="Session Expired" />

          <h4 class="mt-4">Your session has expired.</h4>
          <p class="text-muted mt-2">{{ errorMessage }}</p>

          <div class="mt-4">
            <button type="button" class="btn btn-warning" (click)="goToSessionExpired()">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-5 col-11">
    <app-assist-left></app-assist-left>
  </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>
